import { mediaQuery } from 'constants/ui';

export const summaryGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },
};

export const blocksGridStyles = {
  ...summaryGridStyles,
  gap: '24px',
};

export const compactRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '12px 20px',
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) => palette.background.primary,
  boxShadow: ({ palette }) => palette.shadow.s,
};

export const compactRowLabelStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
};

export const errorContentStyles = {
  minHeight: '64px',
  display: 'flex',
  alignItems: 'center',
};

export const snapdocsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  margin: 0,
  padding: 0,
  listStyle: 'none',
};
